import {
    IAnimateTarget,
    IAnimationData,
    IAnimationPropertyData,
    IPropData
} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/animation/AnimationTypes';
import {AnimateRelatedProperty} from '@mintdata/mint-kit/api/animation/AnimationProps';
import {PropPath} from '@mintdata/mint-kit/api/properties/PropPath';
import {ABoolean} from '@mintdata/mint-kit/api/values/ABoolean';
import {Styler} from 'stylefire';

export const blurData:IAnimationPropertyData = {
    cssProperty: 'filter',
    setter: (animateTarget:IAnimateTarget,
             animationData:IAnimationData,
             styler:Styler,
             property:string,
             cssProperty:string,
             value:any) =>
    {
        const filter:string = styler.get('filter');
        const hasBlur:boolean = /blur\(/.test(filter);
        const newFilter:string = hasBlur
            ? filter.replace(/(.*blur\()(\d+\.?\d*)/, `$1${value}`)
            : `${filter} blur(${value}px)`;

        styler.set('filter', newFilter);
    },
    relatedPropsUpdater: (animationData:IAnimationData, propData:IPropData, value:any) =>
    {
        if( propData.prop )
        {
            const isEnabledPropPath:PropPath = PropPath.fromFieldPath(
                animationData.getPropPath(AnimateRelatedProperty.BlurEnabled)
            );
            const isEnabled:ABoolean = propData.prop.getPropValue(isEnabledPropPath);

            if( !isEnabled || !isEnabled.value )
                propData.prop.setPropValue(isEnabledPropPath, ABoolean.true());
        }
    }
};

export const backgroundBlurData:IAnimationPropertyData = {
    cssProperty: 'backdropFilter',
    setter: (animateTarget:IAnimateTarget,
             animationData:IAnimationData,
             styler:Styler,
             property:string,
             cssProperty:string,
             value:any) =>
    {
        const filter:string = styler.get('backdropFilter');
        const hasBlur:boolean = /blur\(/.test(filter);
        const newFilter:string = hasBlur
            ? filter.replace(/(.*blur\()(\d+\.?\d*)/, `$1${value}`)
            : `${filter} blur(${value}px)`;

        styler.set('backdropFilter', newFilter);
    },
    relatedPropsUpdater: (animationData:IAnimationData, propData:IPropData, value:any) =>
    {
        if( propData.prop )
        {
            const isEnabledPropPath:PropPath = PropPath.fromFieldPath(
                animationData.getPropPath(AnimateRelatedProperty.BackgroundBlurEnabled)
            );
            const isEnabled:ABoolean = propData.prop.getPropValue(isEnabledPropPath);

            if( !isEnabled || !isEnabled.value )
                propData.prop.setPropValue(isEnabledPropPath, ABoolean.true());
        }
    }
};
